module.exports = __webpack_public_path__ + "img/vip-banner-bg.9296d4ce.png";